export default __webpack_public_path__ + "static/media/map-marker.18d93e1a.svg";